import React from 'react'
import styled, { keyframes } from 'styled-components'

const drift = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`

const Text = styled.h1`
position: absolute;
top: ${props => props.$top};
left: ${props => props.$left};
right: ${props => props.$right};
color: transparent;
-webkit-text-stroke: 2px ${props => `rgba(${props.theme.textRgba},0.12)`};
font-size: calc(3rem + 4vw);
z-index: 0;
pointer-events: none;
animation: ${drift} 6s ease-in-out infinite;
`


const BigTitlte = (props) => {
    return (
        <Text  $top={props.top}  $left={props.left}  $right={props.right}>
            {props.text}
        </Text>
    )
}

export default BigTitlte
